var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pdfViewer',{attrs:{"pdfUrl":_vm.pdfUrl,"showDownload":"","showShare":""},on:{"download":_vm.download}})}
var staticRenderFns = []

export { render, staticRenderFns }